function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

function initProductGallery(container) {

  const thumbnailListContainer =
    container.querySelector('.carousel-thumbnail_slider');

  const MainListContainer =
    container.querySelector('.carousel-main_slider');

  if (!thumbnailListContainer || !MainListContainer) {
    return;
  }

  const thumbnailList =
    thumbnailListContainer.querySelectorAll('.slider__slide');

  const customNext =
    container.querySelector('.custom-next');

  const customPrev =
    container.querySelector('.custom-prev');

  const mainCustomNext =
    container.querySelector('button[name="next"]');

  const mainCustomPrev =
    container.querySelector('button[name="previous"]');

  const useThumbnailNav = thumbnailList.length > 4;

  /*
   * Destroy Existing Slick
   */
  $(MainListContainer).off('afterChange.thumbnailSync');

  if ($(MainListContainer).hasClass('slick-initialized')) {
    $(MainListContainer).slick('unslick');
  }

  if ($(thumbnailListContainer).hasClass('slick-initialized')) {
    $(thumbnailListContainer).slick('unslick');
  }

  thumbnailListContainer.classList.toggle('thumbnail-slider--static', !useThumbnailNav);

  /*
   * Main Slider
   */
  $(MainListContainer).slick({
    fade: true,
    dots: false,
    arrows: true,
    nextArrow: mainCustomNext,
    prevArrow: mainCustomPrev,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: false,
    asNavFor: useThumbnailNav ? thumbnailListContainer : null,
  });

  /*
   * Thumbnail Slider
   */
  if (thumbnailList.length > 1) {
    if (useThumbnailNav) {
      $(thumbnailListContainer).slick({
        dots: false,
        arrows: true,
        nextArrow: customNext,
        prevArrow: customPrev,
        speed: 300,
        slidesToShow: Math.min(4, thumbnailList.length),
        slidesToScroll: 1,
        adaptiveHeight: false,
        asNavFor: MainListContainer,
        focusOnSelect: true,
        infinite: false,
        centerMode: false,
      });
    } else {
      const syncThumbnailState = (index) => {
        thumbnailListContainer.querySelectorAll('.slider__slide').forEach((slide, i) => {
          slide.classList.toggle('slick-current', i === index);
          const button = slide.querySelector('button.thumbnail');
          if (button) {
            if (i === index) {
              button.setAttribute('aria-current', 'true');
            } else {
              button.removeAttribute('aria-current');
            }
          }
        });
      };

      if (!thumbnailListContainer.dataset.thumbnailSyncBound) {
        thumbnailListContainer.dataset.thumbnailSyncBound = 'true';
        thumbnailListContainer.addEventListener('click', (event) => {
          const slide = event.target.closest('.slider__slide');
          if (!slide || !thumbnailListContainer.contains(slide)) return;

          const slides = Array.from(
            thumbnailListContainer.querySelectorAll('.slider__slide')
          );
          const index = slides.indexOf(slide);
          if (index < 0 || !$(MainListContainer).hasClass('slick-initialized')) return;

          event.preventDefault();
          $(MainListContainer).slick('slickGoTo', index);
        });
      }

      $(MainListContainer).on('afterChange.thumbnailSync', function (_event, _slick, currentSlide) {
        syncThumbnailState(currentSlide);
      });

      syncThumbnailState(0);
    }
  }

  $(MainListContainer).slick('setPosition');
  if ($(thumbnailListContainer).hasClass('slick-initialized')) {
    $(thumbnailListContainer).slick('setPosition');
  }
}

function slickCallAll(root = document) {
  const galleries = root.querySelectorAll('media-gallery');

  if (galleries.length) {
    galleries.forEach((gallery) => initProductGallery(gallery));
    return;
  }

  initProductGallery(root);
}

function slickCall(container) {
  const root = container || document;
  const isDocument =
    root === document ||
    root.nodeType === 9 ||
    root.nodeName === 'HTML';

  if (isDocument) {
    slickCallAll(root);
    return;
  }

  initProductGallery(root);
}
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

if (
  elementToFocus &&
  typeof elementToFocus.focus === 'function'
) {
  elementToFocus.focus();
}

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    // Cache global elements
    this.errorEl = document.querySelector('.product-form__error-message');
    this.addToCartBtn = document.querySelector('.product-form__buttons');     // adjust selector if needed
    this.buyNowBtn = document.querySelector('[name="checkout"]');   // adjust selector if needed
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    const value = parseInt(this.input.value, 10) || 0;
    const cartQty = parseInt(this.input.dataset.cartQuantity, 10) || 0;
    
    if (value >= cartQty) {
      this.disablePurchaseButtons(true);
      } else {
        this.clearError();
        this.disablePurchaseButtons(false);
      }

    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);

    // Disable minus button at min
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= parseInt(this.input.min));
    }

    // Disable plus button at max
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);

      // ✅ Handle stock availability
      if (value > max) {
        this.showError(`Only ${max} items available`);
        this.disablePurchaseButtons(true);
      } else {
        this.clearError();
        this.disablePurchaseButtons(false);
      }
    }
  }

  showError(message) {
  if (!this.errorEl) return;

  // Prevent duplicate messages
  this.errorEl.textContent = '';
  
  const msg = document.createElement('span');
  msg.className = 'error-text';
  msg.textContent = message;

  this.errorEl.appendChild(msg);
  this.errorEl.classList.add('active');
}

  clearError() {
  if (!this.errorEl) return;
  this.errorEl.textContent = '';
  this.errorEl.classList.remove('active');
}

  disablePurchaseButtons(disabled) {
    if (this.addToCartBtn) this.addToCartBtn.classList.toggle('disabled', disabled);
    if (this.buyNowBtn) this.buyNowBtn.classList.toggle('disabled', disabled);
  }
}

customElements.define('quantity-input', QuantityInput);


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {

  this.openedBy = opener || document.activeElement;

  const popup = this.querySelector('.template-popup');

  document.body.classList.add('overflow-hidden');
  document.body.classList.add('modal-open');

  this.setAttribute('open', '');

  if (popup) {
    popup.loadContent();
  }

  const dialog =
    this.querySelector('[role="dialog"]') ||
    this.querySelector('.quick-add-modal') ||
    this.querySelector('.modal__content') ||
    this;

  if (dialog) {

    requestAnimationFrame(() => {
      if (
  dialog &&
  dialog instanceof HTMLElement
) {

  requestAnimationFrame(() => {

    try {
      trapFocus(this, dialog);
    } catch (e) {}

  });

}
    });

  }

  window.pauseAllMedia();

}

  hide() {
    document.body.classList.remove('overflow-hidden');
     document.body.classList.remove('modal-open');    
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);


class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
  this.sliderItemsToShow = Array.from(this.sliderItems).filter(
    (element) => element.clientWidth > 0
  );

  if (this.sliderItemsToShow.length < 2) {
    this.disableSlider();
    return;
  }

  this.sliderItemOffset =
    this.sliderItemsToShow[1].offsetLeft -
    this.sliderItemsToShow[0].offsetLeft;

  this.slidesPerPage = Math.floor(
    (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
      this.sliderItemOffset
  );

  this.totalPages =
    this.sliderItemsToShow.length - this.slidesPerPage + 1;

  /* ✅ DISABLE SLIDER IF ALL SLIDES ARE VISIBLE */
  if (this.sliderItemsToShow.length <= this.slidesPerPage) {
    this.disableSlider();
    return;
  }

  this.enableSlider();
  this.update();
}

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {    
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

 
  isSlideVisible(element, offset = 0) {
    if (!element) {
        return false; 
    }

    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;

    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
}

  
  onButtonClick(event) {    
    event.preventDefault();        
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  connectedCallback() {

    /*
     * Prevent duplicate listeners
     */
    this.removeEventListener('change', this.onVariantChange);
    this.addEventListener('change', this.onVariantChange);

  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onVariantChange);
  }

 onVariantChange(event) {

  const target = this.getInputForEventTarget(event.target);

  this.updateSelectionMetadata(event);

  publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
    data: {
      event,
      target,
      selectedOptionValues: this.selectedOptionValues,
    },
  });

  /*
   * Wait for Shopify variant update
   */
  requestAnimationFrame(() => {

    const productInfo = this.closest('product-info');

    if (productInfo?.updateVariantStatus) {
      productInfo.updateVariantStatus();
    }

    this.updateSwiperMedias();
    const form = this.closest('product-info') || document;

const addButton = form.querySelector('[name="add"]');

if (addButton) {
  addButton.removeAttribute('disabled');

  const textSpan = addButton.querySelector('span');

  if (textSpan) {
    textSpan.textContent = window.variantStrings.addToCart;
  }
}

  });

}

  updateSelectionMetadata({ target }) {

    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {

      const selectedOption = Array.from(target.options)
        .find((option) => option.hasAttribute('selected'));

      if (selectedOption) {
        selectedOption.removeAttribute('selected');
      }

      target.selectedOptions[0].setAttribute(
        'selected',
        'selected'
      );

      const swatchValue =
        target.selectedOptions[0].dataset.optionSwatchValue;

      const selectedDropdownSwatchValue =
        target
          .closest('.product-form__input')
          ?.querySelector('[data-selected-value] > .swatch');

      if (selectedDropdownSwatchValue) {

        if (swatchValue) {

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch--background',
            swatchValue
          );

          selectedDropdownSwatchValue.classList.remove(
            'swatch--unavailable'
          );

        } else {

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch--background',
            'unset'
          );

          selectedDropdownSwatchValue.classList.add(
            'swatch--unavailable'
          );

        }

        selectedDropdownSwatchValue.style.setProperty(
          '--swatch-focal-point',
          target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
        );

      }

    }
    else if (
      tagName === 'INPUT' &&
      target.type === 'radio'
    ) {

      const selectedSwatchValue =
        target
          .closest('.product-form__input')
          ?.querySelector('[data-selected-value]');

      if (selectedSwatchValue) {
        selectedSwatchValue.innerHTML = value;
      }

    }

  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT'
      ? target.selectedOptions[0]
      : target;
  }

  get selectedOptionValues() {
  return Array.from(
    this.querySelectorAll(
      'select, fieldset input:checked'
    )
  ).map((element) => {
    if (element.tagName === 'SELECT') {
      return element.selectedOptions[0].dataset.optionValueId;
    }
    return element.dataset.optionValueId;
  });
}

  updateSwiperMedias() {

  const quickModal = this.closest('quick-add-modal');

  const scope = quickModal
    ? quickModal.modalContent
    : document;

  const mainSlider =
    scope.querySelector('.carousel-main_slider');

  const thumbSlider =
    scope.querySelector('.carousel-thumbnail_slider');

  if (!mainSlider) return;

  requestAnimationFrame(() => {

    /*
     * DESTROY EXISTING SLICK
     */
    if ($(mainSlider).hasClass('slick-initialized')) {
      $(mainSlider).slick('unslick');
    }

    if (thumbSlider && $(thumbSlider).hasClass('slick-initialized')) {
      $(thumbSlider).slick('unslick');
    }

    /*
     * REINITIALIZE
     */
    slickCall(scope);

    /*
     * FORCE REFRESH
     */
    setTimeout(() => {

      if ($(mainSlider).hasClass('slick-initialized')) {
        $(mainSlider).slick('setPosition');
      }

      if (thumbSlider && $(thumbSlider).hasClass('slick-initialized')) {
        $(thumbSlider).slick('setPosition');
      }

    }, 100);

  });

}
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.recommendation-items')) {
          this.classList.add('product-recommendations--loaded');
          this.initSlider(); 
          DTWishlist();
        }
      })
      .catch((e) => {});
  }

  initSlider() {
    const slider = this.querySelector("[data-slick-slider]");
    const sliderList = this.querySelectorAll('.recommendation-items'); 
    if (!slider) return;
    const sliderOptions = slider.parentElement.getAttribute("data-slider-options");  
    if (!sliderOptions) return;
    const options = JSON.parse(sliderOptions);
    Object.keys(options).forEach(key => {
      if (typeof options[key] === "string" && /^\d+$/.test(options[key])) {
        options[key] = parseInt(options[key], 10);
      }
    });

    const autoplay = options.auto_play > 0 ? options.auto_play * 1000 : false;
    const loop = options.loop === "true" || options.loop === true;
    const centeredSlides = options.mode === "true" || options.mode === true;
    const pagination = options.dots === "true" || options.loop === true;

    const slickOptions = {
      infinite: loop,
      autoplay: !!autoplay,
      autoplaySpeed: autoplay,
      centerMode: centeredSlides,
      prevArrow: slider.parentElement.querySelector(".slick-prev"),
      nextArrow: slider.parentElement.querySelector(".slick-next"),
      dots: pagination,
      dotsClass: 'pagination pt-3',
      customPaging: function (slider, i) {
        return '<span class="page-link rounded-circle m-1 p-1"></span>';
      },
      lazyLoad: 'ondemand',
      slidesToShow: options.desktop,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 2560,
          settings: {
            slidesToShow: options.desktop,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: options.laptop,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: options.tablet,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: options.mobile,
          }
        }
      ],
      ...options.options 
    };

    $(slider).slick(slickOptions);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);



class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);


class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);


if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');            
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            super.show(opener);

            this.reinitializeVariantSelectors();

            setTimeout(() => {
              slickCall(this.modalContent);
            }, 150);

            DTWishlist();                                          
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');          
          });
      }

      preprocessHTML(productElement) {        
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }      
      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

      
        const modalCanvas = productElement.querySelectorAll('.canvas_block');        
        if (modalCanvas) modalCanvas.forEach((canvas) => canvas.remove());

        const modalAccordion = productElement.querySelectorAll('.product__accordion');        
        if (modalAccordion) modalAccordion.forEach((accordion) => accordion.remove());

        const blockPopup = productElement.querySelectorAll('.block-popup');        
        if (blockPopup) blockPopup.forEach((popup) => popup.remove());
        
        const shareButton = productElement.querySelector('.share_button');        
       if (shareButton) shareButton.remove();
        
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }
      reinitializeVariantSelectors() {

  const variantSelectors =
    this.modalContent.querySelectorAll(
      'variant-selects, variant-radios'
    );

  variantSelectors.forEach((selector) => {

    /*
     * Prevent duplicate listeners
     */
    selector.replaceWith(selector.cloneNode(true));

  });

  this.modalContent
    .querySelectorAll('variant-selects, variant-radios')
    .forEach((selector) => {

      if (typeof selector.connectedCallback === 'function') {
        selector.connectedCallback();
      }

    });

}

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
  
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.error = false;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
           
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.error = true;
              this.removeBackdrop(); 

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');

              if (soldOutMessage) {
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }

              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  this.cart.renderContents(response);
                  this.openBackdrop(); 
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response); 
              this.openBackdrop(); 
            }
          })
          .catch((e) => {})
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
          });
      }

      /* =======================
         BACKDROP CONTROLS
      ======================== */

      openBackdrop() {
        if (document.querySelector('.offcanvas-backdrop')) return;

        const backdrop = document.createElement('div');
        backdrop.className = 'offcanvas-backdrop fade show';
        document.body.appendChild(backdrop);

        backdrop.addEventListener('click', () => {
          this.closeCartDrawer();
        });
      }

      closeCartDrawer() {
      const drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.close === 'function') {
        drawer.close(); 
      }

      this.removeBackdrop();
    }
      removeBackdrop() {
        const backdrop = document.querySelector('.offcanvas-backdrop');
        if (backdrop) backdrop.remove();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}
class WDT_slideShow extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector("[data-slick-slider]");
        this.init();
    }

    init() {     
        const sliderOptions = this.slider.parentElement.getAttribute("data-slider-options");    
        if (!sliderOptions) return;
        const options = JSON.parse(sliderOptions);
        
        Object.keys(options).forEach(key => {
            if (typeof options[key] === "string" && /^\d+$/.test(options[key])) {
                options[key] = parseInt(options[key], 10);
            }
        });

        const autoplay = options.auto_play > 0 ? options.auto_play * 1000 : false;
        const loop = options.loop === "true" || options.loop === true;      
        const pagination = options.dots === "true" || options.dots === true;
        const fade = options.fade === "true" || options.fade === true;

        
        const navContainer = this.slider.parentElement.querySelector('.slick-navigation');
        const dotsContainer = document.createElement('div');
        dotsContainer.classList.add('custom-dots'); 
        navContainer.insertBefore(dotsContainer, navContainer.querySelector('.slick-next')); 

        const slickOptions = {        
            fade: fade,
            cssEase: 'linear',          
            infinite: loop,
            autoplay: !!autoplay,
            autoplaySpeed: autoplay,            
            prevArrow: navContainer.querySelector(".slick-prev"),
            nextArrow: navContainer.querySelector(".slick-next"),
            dots: pagination,
            appendDots: dotsContainer, 
            dotsClass: 'pagination',
            customPaging: function(slider, i) {
                return '<a class="dot">' + (i + 1) + '</a>'; 
            },
            lazyLoad: 'ondemand',
            slidesToShow: 1,        
            ...options.options 
        };

        
        $(this.slider).slick(slickOptions);      
    }
}

customElements.define('wdt-slideshow', WDT_slideShow);


class WDT_Slider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[data-slick-slider]');
    this.init();
  }

  init() {
    if (!this.slider) return;

    const sliderOptions = this.slider.parentElement.getAttribute('data-slider-options');
    if (!sliderOptions) return;

    const options = JSON.parse(sliderOptions);

    Object.keys(options).forEach(key => {
      if (typeof options[key] === 'string' && /^\d+$/.test(options[key])) {
        options[key] = parseInt(options[key], 10);
      }
    });

    const autoplay = options.auto_play > 0 ? options.auto_play * 1000 : false;
    const loop = options.loop === 'true' || options.loop === true;
    const centeredSlides = options.mode === 'true' || options.mode === true;
    const pagination = options.dots === 'true' || options.dots === true;

    const slickOptions = {
      infinite: loop,
      autoplay: !!autoplay,
      autoplaySpeed: autoplay,
      centerMode: centeredSlides,
      arrows: false, 
      dots: pagination,
      variableWidth: false,
      dotsClass: 'pagination pt-3',
      lazyLoad: 'ondemand',
      slidesToShow: options.desktop,
      adaptiveHeight: false,
      responsive: [
        { breakpoint: 2560,
           settings:
            { 
              slidesToShow: options.desktop 
            } 
          },

        {
          breakpoint: 1200,
          settings: {
            slidesToShow: options.laptop
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: options.tablet
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: options.mobile
          }
        }
      ],
      ...options.options
    };

    const $slider = $(this.slider);
    $slider.slick(slickOptions);

    /* -----------------------------
       SCOPED EXTERNAL NAVIGATION
    ------------------------------*/

    const wrapper =
      this.closest('.wdt-slider-wrapper') ||
      this.closest('[data-slider-section]') ||
      this.parentElement;

    const prevBtn = wrapper.querySelector('.slick-prev');
    const nextBtn = wrapper.querySelector('.slick-next');

    if (!prevBtn || !nextBtn) return;

    // Navigation click handlers
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!prevBtn.classList.contains('disabled')) {
        $slider.slick('slickPrev');
      }
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!nextBtn.classList.contains('disabled')) {
        $slider.slick('slickNext');
      }
    });

    /* -----------------------------
       DISABLE ARROWS AT EDGES
    ------------------------------*/

    function updateArrows(event, slick, currentSlide) {
      const slidesToShow = slick.options.slidesToShow;
      const slideCount = slick.slideCount;

      // First slide
      if (currentSlide === 0) {
        prevBtn.classList.add('disabled');
      } else {
        prevBtn.classList.remove('disabled');
      }

      // Last slide
      if (currentSlide >= slideCount - slidesToShow) {
        nextBtn.classList.add('disabled');
      } else {
        nextBtn.classList.remove('disabled');
      }
    }

    // Initial state
    updateArrows(null, $slider.slick('getSlick'), 0);

    // Update on change
    $slider.on('afterChange', updateArrows);
  }
}

customElements.define('wdt-slick-slider', WDT_Slider);

class WDT_Contact_Slider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[data-slick-slider]');
    this.init();
  }

  init() {
    if (!this.slider) return;

    const sliderOptions = this.slider.parentElement.getAttribute('data-slider-options');
    if (!sliderOptions) return;

    const options = JSON.parse(sliderOptions);

    Object.keys(options).forEach(key => {
      if (typeof options[key] === 'string' && /^\d+$/.test(options[key])) {
        options[key] = parseInt(options[key], 10);
      }
    });

    const autoplay = options.auto_play > 0 ? options.auto_play * 1000 : false;
    const loop = options.loop === 'true' || options.loop === true;
    const centeredSlides = options.mode === 'true' || options.mode === true;
    const pagination = options.dots === 'true' || options.dots === true;

    const slickOptions = {
      infinite: loop,
      autoplay: !!autoplay,
      autoplaySpeed: autoplay,
      centerMode: centeredSlides,
      arrows: false,
      dots: pagination,
      variableWidth: false,
      dotsClass: 'pagination pt-3',
      lazyLoad: 'ondemand',
      slidesToShow: options.desktop,
      adaptiveHeight: false,
      responsive: [
        { breakpoint: 2560, settings: { slidesToShow: options.desktop } },
        { breakpoint: 1200, settings: { slidesToShow: options.laptop } },
        { breakpoint: 992, settings: { slidesToShow: options.tablet } },
        { breakpoint: 768, settings: { slidesToShow: options.mobile } },
        { breakpoint: 400, settings: { slidesToShow: options.mobile } }
      ],
      ...options.options
    };

    const $slider = $(this.slider);
    const slideCount = $slider.children().length;

    slickOptions.draggable = slideCount > slickOptions.slidesToShow;
    slickOptions.swipe = slideCount > slickOptions.slidesToShow;
    slickOptions.touchMove = slideCount > slickOptions.slidesToShow;

    $slider.slick(slickOptions);

    const wrapper =
      this.closest('.wdt-slider-wrapper') ||
      this.closest('[data-slider-section]') ||
      this.parentElement;

    const prevBtn = wrapper.querySelector('.slick-prev');
    const nextBtn = wrapper.querySelector('.slick-next');

    if (!prevBtn || !nextBtn) return;

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!prevBtn.classList.contains('disabled')) {
        $slider.slick('slickPrev');
      }
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!nextBtn.classList.contains('disabled')) {
        $slider.slick('slickNext');
      }
    });

    function updateArrows(event, slick, currentSlide) {
      const slidesToShow = slick.options.slidesToShow;
      const slideCount = slick.slideCount;

      if (currentSlide === 0) {
        prevBtn.classList.add('disabled');
      } else {
        prevBtn.classList.remove('disabled');
      }

      if (currentSlide >= slideCount - slidesToShow) {
        nextBtn.classList.add('disabled');
      } else {
        nextBtn.classList.remove('disabled');
      }
    }

    updateArrows(null, $slider.slick('getSlick'), 0);
    $slider.on('afterChange', updateArrows);
  }
}

customElements.define('wdt-contact-slick-slider', WDT_Contact_Slider);



document.addEventListener('DOMContentLoaded', function() {   
   slickCallAll();
  cardSwatch();
});

 $(document).ready(function() {   
   if ($('.section-number-counter').length > 0) {

  function runCounter($element) {
    const maxValue = parseInt(
      $element.attr('data-value').replace(/,/g, ''),
      10
    ) || 0;

    const startValue = 0;

    $({ counter: startValue }).animate(
      { counter: maxValue },
      {
        duration: 1500,
        easing: 'swing',
        step: function () {
          $element.text(Math.floor(this.counter));
        },
        complete: function () {
          $element.text(
            maxValue.toLocaleString()
          );
        }
      }
    );
  }

  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const $el = $(entry.target);
          runCounter($el);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.3
    }
  );

  $('.number-counter-value').each(function () {
    observer.observe(this);
  });
}


//cookie banner 
   var cookie = false;
    var cookieContent = $('.cookie-disclaimer');    
    checkCookie();
    if (cookie === false) {
      cookieContent.css("display","flex");
      cookieContent.css("justify-content","end");
      cookieContent.css("align-items","end");
    }
    
    if (cookie === true) {
      cookieContent.css("display","none");
    }
    
    function setCookie(cname, cvalue, exdays) {
  		var d = new Date();
  		d.setTime(d.getTime() + (exdays*24*60*60*1000));
  		var expires = "expires="+ d.toUTCString();
  		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
    
    function getCookie(cname) {
  		var name = cname + "=";
  		var decodedCookie = decodeURIComponent(document.cookie);
  		var ca = decodedCookie.split(';');
  		for(var i = 0; i < ca.length; i++) {
    	var c = ca[i];
    	while (c.charAt(0) == ' ') {
      	c = c.substring(1);
    	}
    	if (c.indexOf(name) == 0) {
      		return c.substring(name.length, c.length);
    	}
  		}
  		return "";
	}
    
    function checkCookie() {
      var user = getCookie("hldn_consent_choice");
      if (user !== "") {        
        cookie = true;
        if (user === "accepted") {                  
        }
      }
    }

    $('.accept-cookie').click(function () {
      setCookie("hldn_consent_choice", "accepted", 365);
      cookieContent.css("display","none");
    });

    $('.decline-cookie').click(function () {    
      setCookie("hldn_consent_choice", "declined", 365);
      cookieContent.css("display","none");
    });

   // Sugessted Items
   if ($.cookie('dT_suggested-cookie') == 'closed') {
    $('.customer-who-purchased').remove();
  }

  $('.dT_close').bind('click',function(){
    $('.customer-who-purchased').remove();
    $.cookie('dT_suggested-cookie', 'closed', {expires:1, path:'/'});
  });      

  var elements = $('.customer-who-purchased li');
  var init_element = 0;
  var i = 0;
 
  elements.removeClass('active');
  function fadeInRandomElement() { 
    if ( i % 2 == 0) {
      var currentItem = elements.eq(init_element);      
      currentItem.addClass('active');
      setTimeout(function(){ 
        currentItem.removeClass('active')
      }, 8000);

      init_element++;
      if(elements.length == init_element) {
        init_element = 0;
      }

    }
    i++;
  }
  setInterval(function(){ 
    fadeInRandomElement();
  }, 8000);   
});

  AOS.init({
    startEvent: 'DOMContentLoaded',
    once: true,
    offset: 50, 
    delay: 0, 
    duration: 1000    
  });
  window.addEventListener('load', function() {
    AOS.refresh();
  });
 
document.addEventListener('shopify:block:deselect', function () {
  document.querySelectorAll('.carousel-thumbnail_slider.slick-initialized').forEach((slider) => {
    $(slider).slick('unslick');
  });
  slickCallAll();
});

document.addEventListener('shopify:section:load', () => {
  slickCallAll();
});

function cardSwatch() {
   $("body").on("click", ".item-swatch span", function () {    
    var featuredMedia = $(this).parents(".card-main").find(".card__inner .featured-media").attr("srcset", $(this).data("image"));      
    if ($(this).parents(".card-swatch").hasClass("color")) {
      const variant = $(this).data("id");
      $(this).parents(".card-main").find(".product-variant-id").val(variant);
      var swatch_item = $(this).data("variant-item");
  };
});
}


class VerticalBar extends HTMLElement {
    constructor() {
      super();
      this.container = document.querySelector('.vertical-marquee-selector');
      
      // Initialize Slick
      $(this.container).slick({
        vertical: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        nextArrow: this.container.parentElement.querySelector('.vertical-marquee-next'),
        prevArrow: this.container.parentElement.querySelector('.vertical-marquee-prev')
      });
    }
  }
  customElements.define('vertical-bar', VerticalBar);



 $(document).ready(function() {
    function makeTimer() {
      $('.product-deal-count').each(function() {
        var endTime = new Date($(this).attr('data-end-time'));    
        endTime = (Date.parse(endTime) / 1000);

        var now = new Date();
        now = (Date.parse(now) / 1000);

        var timeLeft = endTime - now;

        if (timeLeft > 0) {
          var days = Math.floor(timeLeft / 86400); 
          var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
          var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600)) / 60);
          var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

          if (hours < 10) { hours = "0" + hours; }
          if (minutes < 10) { minutes = "0" + minutes; }
          if (seconds < 10) { seconds = "0" + seconds; }

          $(this).find(".days").html(days );
          $(this).find(".hours").html(hours)  ;
          $(this).find(".minutes").html(minutes) ;
          $(this).find(".seconds").html(seconds );
        } else {
          $(this).find(".deal-label").hide();
        }
      });
    }

    setInterval(makeTimer, 1000);
  });

$(document).ready(function () {
  $('.compare-container').each(function () {
    const $container = $(this);
    const $slider = $container.find('.drag-slider');

    if ($slider.length) {

     
      $container.css('--position', '50%');
      $slider.val(50);

      $slider.on('input', function () {
        $container.css('--position', `${$(this).val()}%`);
      });
    }
  });
});


 document.querySelectorAll('.accordion-button').forEach(btn => {
  btn.addEventListener('click', function () {

    
    document.querySelectorAll('.accordion-item').forEach(item => {
      item.classList.remove('prev-active');
    });

    const currentItem = this.closest('.accordion-item');

    const prevItem = currentItem.previousElementSibling;

    if (prevItem) {
      prevItem.classList.add('prev-active');
    }
  });
});

// Force cart drawer to refresh its content
function forceCartContentRefresh() {
  console.log('Forcing cart content refresh...');
  
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) {
    console.log('Cart drawer not found');
    return;
  }
  
  // Fetch fresh cart data
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      console.log('Cart data fetched:', cartData);
      
      // Update cart counts in header
      updateCartCounts(cartData.item_count);
      
      // Method 1: If cart drawer has renderContents method
      if (typeof cartDrawer.renderContents === 'function') {
        console.log('Using renderContents method');
        cartDrawer.renderContents(cartData);
      }
      
      // Method 2: Refresh by fetching cart drawer section
      refreshCartDrawerHTML();
      
      // Method 3: Trigger cart-items update
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItems && typeof cartItems.onCartUpdate === 'function') {
        console.log('Triggering cart-items onCartUpdate');
        cartItems.onCartUpdate();
      }
      
      // Update drawer totals
      updateCartTotals(cartData);
    })
    .catch(error => {
      console.error('Failed to fetch cart:', error);
      // Fallback: reload the page
      setTimeout(() => {
        location.reload();
      }, 1000);
    });
}

function refreshCartDrawerHTML() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;
  
  // Fetch the cart drawer section HTML
  const sectionId = cartDrawer.dataset.sectionId || 'cart-drawer';
  fetch(`${window.location.pathname}?section_id=${sectionId}`)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartDrawer = doc.querySelector('cart-drawer');
      
      if (newCartDrawer) {
        // Replace the entire cart drawer content
        cartDrawer.innerHTML = newCartDrawer.innerHTML;
        
        // Reinitialize event listeners
        reinitializeCartEventListeners();
      }
    })
    .catch(error => console.error('Failed to refresh cart drawer:', error));
}

function updateCartCounts(itemCount) {
  const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart-count, .header__cart-count, [data-cart-count]');
  cartCountElements.forEach(element => {
    element.textContent = itemCount;
    element.classList.remove('hidden');
  });
  
  // Update cart icon aria label
  const cartIcon = document.querySelector('.header__icon--cart');
  if (cartIcon) {
    cartIcon.setAttribute('aria-label', `Cart with ${itemCount} items`);
  }
}

function updateCartTotals(cartData) {
  // Update total price
  const totalElements = document.querySelectorAll('.cart-total, .cart-drawer__total, .totals__total-value');
  totalElements.forEach(element => {
    if (cartData.total_price) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: cartData.currency || 'USD'
      });
      element.textContent = formatter.format(cartData.total_price / 100);
    }
  });
  
  // Update item count text
  const itemCountElements = document.querySelectorAll('.cart-item-count, .cart-drawer__item-count');
  itemCountElements.forEach(element => {
    element.textContent = `${cartData.item_count} ${cartData.item_count === 1 ? 'item' : 'items'}`;
  });
}

function reinitializeCartEventListeners() {
  // Re-initialize quantity inputs
  document.querySelectorAll('quantity-input').forEach(el => {
    if (typeof el.connectedCallback === 'function') {
      el.connectedCallback();
    }
  });
  
  // Re-initialize cart remove buttons
  document.querySelectorAll('cart-remove-button').forEach(el => {
    // Clone and replace to refresh event listeners
    const newEl = el.cloneNode(true);
    el.parentNode.replaceChild(newEl, el);
  });
}

function showCartDrawerWithBackdrop() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;
  
  // First refresh content
  forceCartContentRefresh();
  
  // Remove existing backdrop
  const existingBackdrop = document.querySelector('.cart-drawer-backdrop');
  if (existingBackdrop) existingBackdrop.remove();
  
  // Create backdrop
  const backdrop = document.createElement('div');
  backdrop.className = 'cart-drawer-backdrop';
  backdrop.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
    opacity: 0;
    transition: opacity 0.3s ease;
    cursor: pointer;
  `;
  document.body.appendChild(backdrop);
  
  // Fade in backdrop
  setTimeout(() => {
    backdrop.style.opacity = '1';
  }, 10);
  
  // Open drawer
  cartDrawer.classList.add('active', 'is-open');
  document.body.classList.add('overflow-hidden');
  document.body.style.overflow = 'hidden';
  
  // Close handlers
  backdrop.addEventListener('click', () => {
    closeCartDrawer(backdrop, cartDrawer);
  });
  
  // ESC key handler
  const escHandler = (e) => {
    if (e.key === 'Escape') {
      closeCartDrawer(backdrop, cartDrawer);
      document.removeEventListener('keydown', escHandler);
    }
  };
  document.addEventListener('keydown', escHandler);
  
  window.currentBackdrop = backdrop;
}

function closeCartDrawer(backdrop, cartDrawer) {
  if (cartDrawer) {
    cartDrawer.classList.remove('active', 'is-open');
  }
  
  if (backdrop) {
    backdrop.style.opacity = '0';
    setTimeout(() => {
      if (backdrop && backdrop.parentNode) {
        backdrop.parentNode.removeChild(backdrop);
      }
    }, 300);
  }
  
  document.body.classList.remove('overflow-hidden');
  document.body.style.overflow = '';
}